module.exports = __webpack_public_path__ + "static/media/default_cover.3ccd107c.jpg";